import { type RefObject, useLayoutEffect, useRef, useState } from 'react';

export const useResizeObserver = (
  ref?: RefObject<HTMLDivElement>
): {
  containerRef: RefObject<HTMLDivElement>;
  width: number;
  height: number;
} => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const container = ref?.current || containerRef.current;
    if (!container) return;

    const rect = container.getBoundingClientRect();
    setWidth(rect.width);
    setHeight(rect.height);

    const resizeObserver = new ResizeObserver(() => {
      const { width, height } = container.getBoundingClientRect();
      setWidth(width);
      setHeight(height);
    });
    resizeObserver.observe(container);
    return () => {
      resizeObserver.disconnect();
    };
  }, [ref]);

  return { containerRef: ref || containerRef, width, height };
};
